import React, { useEffect } from 'react';

import Actions from '../action';
import AtmLocationsPresentational from './AtmLocationsPresentational';
import Selectors from '../selectors';
import { TOKEN_URL } from '@constants/app-constants';
import axios from 'axios';
import { connect } from 'react-redux';
import { useState } from 'react';

const AtmLocationsFunctional = ({ atmlocationData, getAtmLocationData, isAtmLoading, getAtmAccessToken, isAtmAccessTokenSuccess }) => {
	const [atmCoordinates, setAtmCoordinates] = useState({
		lat: 25.188841540766923,
		long: 55.258509215340396,
	});
	const [isLoading, setIsLoading] = useState(false);
	const [atmsC, setAtmsC] = useState(true);
	const [rakbankAtm, setRakbankAtm] = useState(true);
	const [atmData, setatmData] = useState(atmlocationData);
	const [selectedEmirate, setSelectedEmirate] = useState(null);
	const [markerOff, setMarkerOff] = useState(false);
	const [allEmirates, setAllEmirates] = useState(false);
	const [locationList, setLocationList] = useState(false);
	const [offset, setOffset] = useState(0);
	const [defaultSwitch, setDefaultSwitch] = useState(false);
	const [tokeSuccess, setTokeSuccess] = useState(false);
	const [infoData, setInfoData] = useState([]);
	const [locationData, setLocationData] = useState(null);
	const [nodata, setNodata] = useState(true);
	const [enableLocationPromt, setEnableLocationPromt] = useState(false);
	const [emiratesStates, setEmiratesStates] = useState({
		allEmirates: false,
		abudhabi: false,
		ajman: false,
		alain: false,
		dubai: false,
		fujairah: false,
		rasalkhaimah: false,
		sharjah: false,
	});
	useEffect(() => {
		if (!localStorage.getItem('token')) {
			// getAtmAccessToken();
		}
	}, []);

	useEffect(() => {
		if (navigator.geolocation) {
			// navigator.permissions.query({ name: 'geolocation' }).then(function (result) {
			// 	if (result.state === 'granted') {
			// 		console.log(result.state);
			// 		console.log('lol not denied', result.state);
			// 	} else if (result.state === 'prompt') {
			// 		console.log(result.state);
			// 	} else if (result.state === 'denied') {
			// 		console.log('lol denied');
			// 		setEnableLocationPromt(true);
			// 	}
			// 	// result.onchange = function () {
			// 	// 	setEnableLocationPromt(true);
			// 	// 	console.log(result.state);
			// 	// };
			// });
		}
	}, []);
	useEffect(() => {
		if (localStorage.getItem('token')) {
			getAtmLocationData();
		}
		getAtmLocationData();
	}, [isAtmAccessTokenSuccess]);

	useEffect(() => {
		setatmData(atmlocationData);
	}, [atmlocationData]);
	const EnableLocation = (bool) => {
		if (bool) {
			setEnableLocationPromt(true);
		} else {
			setEnableLocationPromt(false);
		}
	};
	let data = [
		{
			address: 'Madninat Zayed Shopping center Mall',
			area: 'Abu dhabi',
			description: 'ATM located opposite to the Lulu hypermarket,ground floor.',
			lat: 13.0827,
			long: 80.2707,
		},
		{
			address: 'Madninat Zayed Shopping center Mall',
			area: 'Abu dhabi',
			description: 'ATM located opposite to the Lulu hypermarket,ground floor.',
			lat: 25.2048,
			long: 55.2708,
		},
		{
			address: 'Madninat Zayed Shopping center Mall',
			area: 'Abu dhabi',
			description: 'ATM located opposite to the Lulu hypermarket,ground floor.',
			lat: 13.0827,
			long: 80.2707,
		},
		{
			address: 'Madninat Zayed Shopping center Mall',
			area: 'Abu dhabi',
			description: 'ATM located opposite to the Lulu hypermarket,ground floor.',
			lat: 13.0827,
			long: 80.2707,
		},
		{
			address: 'Madninat Zayed Shopping center Mall',
			area: 'Abu dhabi',
			description: 'ATM located opposite to the Lulu hypermarket,ground floor.',
			lat: 13.0827,
			long: 80.2707,
		},
		{
			address: 'Madninat Zayed Shopping center Mall',
			area: 'Abu dhabi',
			description: 'ATM located opposite to the Lulu hypermarket,ground floor.',
			lat: 13.0827,
			long: 80.2707,
		},
	];

	function searchFilter(evt) {
		let newar = atmlocationData.filter(function (el) {
			let temp =
				el.name != null
					? el.name.toLowerCase().replaceAll(' ', '').includes(evt.target.value.toLowerCase().replaceAll(' ', ''))
					: el.emirate.toLowerCase().replaceAll(' ', '').includes(evt.target.value.toLowerCase().replaceAll(' ', ''));
			return temp;
		});
		setatmData(newar);
		if (newar[0]?.coordinate && newar[0].coordinate.length > 0) {
			let filterCord = newar[0].coordinate.split(',');

			let cord = {
				lat: parseFloat(filterCord[0]),
				long: parseFloat(filterCord[1]),
			};
			setAtmCoordinates(cord);
			console.log('newar', cord);
		}
		if ('notopentopublic'.includes(evt.target.value.toLowerCase().replaceAll(' ', ''))) {
			let notOpenToPublic = atmlocationData.filter(function (el) {
				let temp = el.site == 'Not open to public';

				return temp;
			});
			setatmData(notOpenToPublic);
		}
		if (evt.target.value?.length == 0) {
			setatmData(atmlocationData);
		}
		if (evt.target.value?.length > 0) {
			setNodata(false);
		} else {
			setNodata(true);
		}
		// let temp = { lat: 25.2968466, long: 55.3831503 };
	}

	const handleC3Click = (data) => {
		let lat = data?.lat;
		let temp = atmlocationData.filter((data) => {
			let ra = data.coordinate.split(',');
			if (parseFloat(ra[0]) === parseFloat(lat)) {
				return data;
			}
		});

		temp = temp[0];
		setInfoData(temp);
		setDefaultSwitch(true);
	};
	function onAtmClick(lat, lng) {
		let temp = {
			lat: lat,
			long: lng,
		};
		console.log('temptemp', temp);
		setAtmCoordinates(temp);
		setMarkerOff(false);
		setAllEmirates(false);
		setLocationList(true);
		handleC3Click(temp);
	}
	function emiratesLocation(val) {
		let cor;
		switch (val) {
			case 'abudhabi':
				cor = {
					lat: 24.483858,
					long: 54.36518,
				};
				break;
			case 'ajman':
				cor = {
					lat: 25.410078,
					long: 55.444283,
				};
				break;
			case 'alain':
				cor = {
					lat: 24.2220025,
					long: 55.7697103,
				};
				break;
			case 'dubai':
				cor = {
					lat: 25.2968466,
					long: 55.3831503,
				};
				break;
			case 'fujairah':
				cor = {
					lat: 25.0836698,
					long: 56.2881682,
				};
				break;
			case 'rasalkhaimah':
				cor = {
					lat: 25.717026,
					long: 55.840415,
				};
				break;
			case 'sharjah':
				cor = {
					lat: 25.355856,
					long: 55.3888462,
				};
				break;
			case 'allemirates':
				cor = {
					lat: 25.558134,
					long: 55.393623,
				};
				setLocationList(false);
				break;
			default:
				break;
		}
		if (val !== 'allemirates') {
			setLocationList(true);
		}
		if (val === 'allemirates') {
			setEmiratesStates({
				...emiratesStates,
				allEmirates: true,
				abudhabi: true,
				ajman: true,
				alain: true,
				dubai: true,
				fujairah: true,
				rasalkhaimah: true,
				sharjah: true,
			});
		}
		if (emiratesStates.allEmirates === true) {
			setEmiratesStates({
				...emiratesStates,
				allEmirates: false,
				abudhabi: false,
				ajman: false,
				alain: false,
				dubai: false,
				fujairah: false,
				rasalkhaimah: false,
				sharjah: false,
			});
		}
		handleC3Click(cor);
		setAtmCoordinates(cor);
		setSelectedEmirate(val);
	}
	console.log('enableLocationPromt', enableLocationPromt);
	return (
		<AtmLocationsPresentational
			searchFilter={searchFilter}
			setEnableLocationPromt={setEnableLocationPromt}
			data={data}
			onAtmClick={onAtmClick}
			atmCoordinates={atmCoordinates}
			emiratesLocation={emiratesLocation}
			atmlocationData={atmData}
			isAtmLoading={isAtmLoading}
			setAtmsC={setAtmsC}
			atmsC={atmsC}
			rakbankAtm={rakbankAtm}
			setRakbankAtm={setRakbankAtm}
			selectedEmirate={selectedEmirate}
			emiratesStates={emiratesStates}
			setEmiratesStates={setEmiratesStates}
			markerOff={markerOff}
			allEmirates={allEmirates}
			locationList={locationList}
			infoData={infoData}
			defaultSwitch={defaultSwitch}
			setDefaultSwitch={setDefaultSwitch}
			setatmData={setatmData}
			nodata={nodata}
			setNodata={setNodata}
			locationData={locationData}
			setLocationData={setLocationData}
			EnableLocation={EnableLocation}
			enableLocationPromt={enableLocationPromt}
		/>
	);
};
const mapStateToProps = (state) => {
	return {
		atmlocationData: Selectors.atmLocationData(state),
		isAtmLoading: Selectors.isAtmLoading(state),
		isAtmAccessTokenSuccess: Selectors.isAtmAccessTokenSuccess(state),
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		getAtmLocationData: () => dispatch(Actions.creators.getAtmLocationData()),
		getAtmAccessToken: () => dispatch(Actions.creators.getAtmAccessToken()),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(AtmLocationsFunctional);
export default Connected;
